// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"az_h8c","badgeV2":"az_i8c","badgeText":"az_j8c","badgeContainerEnd":"az_k8c","badgeHashMarks":"az_l8c","badgeHashMark":"az_m8c"};